function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M67.754,39.443h-6.469V25.908C61.285,11.622,49.664,0,35.377,0C21.091,0,9.469,11.622,9.469,25.908v13.535H3 c-1.656,0-3,1.344-3,3V97c0,1.656,1.344,3,3,3h64.754c1.656,0,3-1.344,3-3V42.443C70.754,40.787,69.41,39.443,67.754,39.443  M15.469,25.908C15.469,14.931,24.399,6,35.377,6s19.908,8.931,19.908,19.908v13.535H15.469V25.908z M64.754,94H6V45.443h58.754V94z "
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.377,61.653c1.657,0,3-1.344,3-3v-0.084c0-1.655-1.343-2.959-3-2.959s-3,1.386-3,3.043 C32.377,60.309,33.72,61.653,35.377,61.653"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.377,84.874c1.657,0,3-1.344,3-3V67.5c0-1.656-1.343-3-3-3s-3,1.344-3,3v14.373 C32.377,83.53,33.72,84.874,35.377,84.874"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 72,
    height: 101,
    viewBox: "-0.529 -0.399 72 101",
    enableBackground: "new -0.529 -0.399 72 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.496d6cf1.svg";
export { ForwardRef as ReactComponent };